import { render, staticRenderFns } from "./spouseInfo.vue?vue&type=template&id=85422742"
import script from "./spouseInfo.vue?vue&type=script&lang=js"
export * from "./spouseInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports